import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Link, useLocation, useParams } from 'react-router-dom';
import { deleteMAEAA020, getMAEAA020, resetBannerADView } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_BANNERS, MESSAGE } from '../../../shared/constants/app';
import { formatDate, getImageSrc, getImgFolder } from '../../../utils';

const MAEAA030 = () => {
    const location = useLocation();
    const { id } = useParams();
    const [data, setData] = useState({
        useYN: 'Y',
    });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [selectedOptionTwo, setSelectedOptionTwo] = useState('');
    console.log('render:', selectedOption, selectedOptionTwo);
    const [fileData, setFileData] = useState({});
    const fileInputRef = useRef(null);
    const [day, setDay] = useState(0);
    const [backgroundColor, setBackgroundColor] = useState('#ffffff');
    const [isEyedropperSupported, setIsEyedropperSupported] = useState(false);

    useEffect(() => {
        if ('EyeDropper' in window) {
            setIsEyedropperSupported(true);
        }
    }, []);

    const handleEyedropperClick = () => {
        if (!isEyedropperSupported) {
            alert('Eyedropper tool is not supported in your browser.');
            return;
        }

        const eyeDropper = new window.EyeDropper();

        eyeDropper
            .open()
            .then((result) => {
                setBackgroundColor(result.sRGBHex);
            })
            .catch((error) => {
                console.error('Error selecting color:', error);
            });
    };

    const handleChangeBackgroundColor = (e) => {
        setBackgroundColor(e.target.value);
    };

    const getSecondSelectOptions = (selectedOption) => {
        switch (selectedOption) {
            case 'MAIN':
                return [
                    { value: 'MAIN', text: '메인' },
                    { value: 'MAINTOP', text: '메인 TOP 배너' },
                    { value: 'GRAND', text: '그랜드 배너' },
                    { value: 'GRANDSUB', text: '그랜드 서브 배너' },
                    { value: 'PREMIUM', text: '프리미엄 배너' },
                    { value: 'CORP', text: '기업배너' },
                    { value: 'MAINRESUME', text: 'HOT 인재 배너' },
                ];
            case 'SUB':
                return [
                    { value: 'RECRUIT', text: '채용소식 줄 배너' },
                    { value: 'RESUME', text: '인재소식 줄 배너' },
                    { value: 'LNB', text: '좌측 LNB 하단 배너' },
                ];
            case 'ETC':
                return [
                    { value: 'LOGIN', text: '로그인 배너' },
                    { value: 'QUICK', text: '우측 퀵 배너' },
                ];
            default:
                return [];
        }
    };

    useEffect(() => {
        if (id) {
            getMAEAA020(id)
                .then(({ data }) => {
                    setData(data);
                    if (data?.startDate && data?.endDate) {
                        const start = moment(data?.startDate);
                        const end = moment(data?.endDate);
                        const day = end.diff(start, 'day');
                        setDay(day);
                    }
                    setFileData({
                        imageFileMain: {
                            name: data?.imgNameMain,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameMain),
                        },
                        imgNameAppMain320px: {
                            name: data?.imgNameAppMain320px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain320px),
                        },
                        imgNameAppMain640px: {
                            name: data?.imgNameAppMain640px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain640px),
                        },
                        imgNameAppMain960px: {
                            name: data?.imgNameAppMain960px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain960px),
                        },
                    });

                    setStartDate(data?.startDate);
                    setEndDate(data?.endDate);
                    if (data?.backgroundColor !== null) setBackgroundColor(data?.backgroundColor);
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    useEffect(() => {
        if (data?.adType) {
            const adType = data.adType;

            const optionMapping = {
                MAIN: 'MAIN',
                MAINTOP: 'MAIN',
                GRAND: 'MAIN',
                GRANDSUB: 'MAIN',
                PREMIUM: 'MAIN',
                MAINRESUME: 'MAIN',
                RECRUIT: 'SUB',
                RESUME: 'SUB',
                LNB: 'SUB',
                LOGIN: 'ETC',
                QUICK: 'ETC',
            };

            const selectedOption = optionMapping[adType] || 'MAIN';
            setSelectedOption(selectedOption);

            console.log(adType)
            setSelectedOptionTwo(adType);
        }
    }, [data]);

    // useEffect(() => {
    //     const secondOptions = getSecondSelectOptions(selectedOption);
    //     setSelectedOptionTwo(secondOptions.length > 0 ? secondOptions[0].value : '');
    //     // eslint-disable-next-line
    // }, [selectedOption]);

    useEffect(() => {
        if (startDate && endDate) {
            const start = moment(startDate);
            const end = moment(endDate);
            const diff = end.diff(start, 'days');
            setDay(diff);
        }
    }, [startDate, endDate]);

    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAEAA020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/maeaa010';
                })
                .catch((error) => console.log(error));
        }
    };

    const handleReset = () => {
        const isConfirm = window.confirm('노출/클릭 수 0으로 초기화하시겠습니까?');
        if (isConfirm) {
            resetBannerADView(id)
                .then(() => {
                    window.alert('완료되었습니다.');
                    window.location.href = '/maeaa010';
                })
                .catch((error) => console.log(error));
        }
    };


    const getLinkTypeText = (value) => {
        switch (value) {
            case '_self':
                return '페이지(_self)';
            case '_blank':
                return '페이지 (_blank, 새창)';
            case 'window':
                return '팝업창';
            default:
                return 'Link type 선택';
        }
    };

    const getLinkTypeAppText = (value) => {
        switch (value) {
            case '_self':
                return '페이지(_self)';
            case '_blank':
                return '페이지 (_blank, 새창)';
            case 'window':
                return '팝업창';
            default:
                return 'Link type 선택';
        }
    };

    return (
        <div className="container">
            <div className="wrap content">
                <SideMenu menu={MENU_BANNERS} />
                <div className="manager-banner-content-change-content content-right">
                    <div id="manager-banner-content-change-content-list">
                        <div className="title title-manager-banner">광고관리</div>
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>구분 선택</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box d-flex gap-2">
                                            <span>
                                                {(() => {
                                                    const found = getSecondSelectOptions(selectedOption).find(
                                                        (option) => option.value === selectedOptionTwo,
                                                    );
                                                    return found ? found.text : '';
                                                })()}
                                            </span>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>배너명</span>
                                    </th>
                                    <td colSpan={3}>{data?.title || ''}</td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        <span>배너 등록</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2}>
                                        <span>웹</span>
                                    </th>
                                    <th className="require">
                                        <span>이미지</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-input" style={{ marginTop: '10px' }}>
                                            {fileData.imageFileMain?.name || ''}
                                        </div>
                                        <div className="preview-image">
                                            {fileData.imageFileMain?.preview && (
                                                <img
                                                    src={fileData.imageFileMain.preview}
                                                    alt="Preview"
                                                    className="resume__image"
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require">
                                        <span>url</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box" style={{ display: 'flex', gap: '10px' }}>
                                            <p>{getLinkTypeText(data?.linkType)}</p> |
                                            {data?.linkType === 'window' && (
                                                <>
                                                    <p>{data?.linkWinName} </p> |
                                                </>
                                            )}
                                            <p>{data?.linkUrl || ''}</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2}>
                                        <span>모바일</span>
                                    </th>
                                    <th className="require">
                                        <span>이미지</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-input">{fileData.imgNameAppMain320px?.name || ''}</div>
                                        {selectedOptionTwo === 'MAINTOP' && (
                                            <>
                                                <div className="group-input" style={{ marginTop: '10px' }}>
                                                    <input
                                                        type="file"
                                                        className="file-input"
                                                        id="imgNameAppMain640px"
                                                        accept="image/*"
                                                        ref={fileInputRef}
                                                    />
                                                    <label htmlFor="imgNameAppMain640px">파일 선택 (640px)</label>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={fileData.imgNameAppMain640px?.name || ''}
                                                    />
                                                </div>
                                                <div className="group-input" style={{ marginTop: '10px' }}>
                                                    <input
                                                        type="file"
                                                        className="file-input"
                                                        id="imgNameAppMain960px"
                                                        accept="image/*"
                                                        ref={fileInputRef}
                                                    />
                                                    <label htmlFor="imgNameAppMain960px">파일 선택 (960px)</label>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={fileData.imgNameAppMain960px?.name || ''}
                                                    />
                                                </div>
                                            </>
                                        )}

                                        <div className="preview-image">
                                            {fileData.imgNameAppMain320px?.preview && (
                                                <img
                                                    src={fileData.imgNameAppMain320px.preview}
                                                    alt="Preview"
                                                    className="resume__image"
                                                />
                                            )}
                                            {selectedOptionTwo === 'MAINTOP' && (
                                                <>
                                                    {fileData.imgNameAppMain640px?.preview && (
                                                        <img
                                                            src={fileData.imgNameAppMain640px.preview}
                                                            alt="Preview"
                                                            className="resume__image"
                                                        />
                                                    )}
                                                    {fileData.imgNameAppMain960px?.preview && (
                                                        <img
                                                            src={fileData.imgNameAppMain960px.preview}
                                                            alt="Preview"
                                                            className="resume__image"
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        {selectedOptionTwo === 'MAINTOP' && (
                                            <div className="color-picker">
                                                <HexColorPicker color={backgroundColor} onChange={setBackgroundColor} />
                                                <div className="d-flex align-items-center mt-3">
                                                    <button className="btn" onClick={handleEyedropperClick}>
                                                        <i className="icon icon-eye-dropper"></i>
                                                    </button>
                                                    <p>
                                                        선택된 컬러:{' '}
                                                        <input
                                                            style={{ width: '105px' }}
                                                            type="text"
                                                            value={backgroundColor || '#ffffff'}
                                                            onChange={handleChangeBackgroundColor}
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require">
                                        <span>url</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box" style={{ display: 'flex', gap: '10px' }}>
                                            <p>{getLinkTypeAppText(data?.linkTypeApp)}</p> |
                                            <p>{data?.linkUrlApp || ''}</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>진행기간</span>
                                    </th>
                                    <td>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    {data?.adType === 'MAINTOP'
                                                        ? moment(startDate).format('YYYY.MM.DD HH:mm')
                                                        : formatDate(startDate)}
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    {data?.adType === 'MAINTOP'
                                                        ? moment(endDate).format('YYYY.MM.DD HH:mm')
                                                        : formatDate(endDate)}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <th>
                                        <span>진행기간</span>
                                    </th>
                                    <td>{day}</td>
                                </tr>
                                <tr>
                                    <th colSpan={2}>
                                        <span>노출 순서</span>
                                    </th>
                                    <td>
                                        <div className="group-input-column">
                                            <p>
                                                <span style={{ fontWeight: '600' }}>{data?.adPosition || ''}</span>
                                                <span style={{ marginLeft: '10px' }}>
                                                    *메인화면 리스트에서 보여질 순서입니다.
                                                </span>
                                            </p>
                                        </div>
                                    </td>
                                    <th className="require border-b-ddd">
                                        <span>공개여부</span>
                                    </th>
                                    <td>
                                        <fieldset id="useYN" className="radio-group">
                                            {data.useYN === 'Y' && (
                                                <div className="item-radioBox">
                                                    <input
                                                        style={{ cursor: 'default' }}
                                                        type="radio"
                                                        name="useYN"
                                                        value="Y"
                                                        id="UseY"
                                                        checked={data.useYN === 'Y'}
                                                        readOnly
                                                    />
                                                    <span />
                                                    <label htmlFor="UseY">
                                                        <span style={{ cursor: 'default' }}>공개</span>
                                                    </label>
                                                </div>
                                            )}
                                            {data.useYN === 'N' && (
                                                <div className="item-radioBox">
                                                    <input
                                                        style={{ cursor: 'default' }}
                                                        type="radio"
                                                        name="useYN"
                                                        value="N"
                                                        id="UseN"
                                                        checked={data.useYN === 'N'}
                                                        readOnly
                                                    />
                                                    <span />
                                                    <label htmlFor="UseN">
                                                        <span style={{ cursor: 'default' }}>비공개</span>
                                                    </label>
                                                </div>
                                            )}
                                        </fieldset>
                                    </td>
                                </tr>
                                {/* <tr>
                                    <th colSpan={2}>
                                        <span>위치</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-columns">
                                            <table className="table-gray">
                                                <tbody>
                                                    <tr>
                                                        <td>노출</td>
                                                        <td>1</td>
                                                        <td>2</td>
                                                        <td>3</td>
                                                    </tr>
                                                    <tr>
                                                        <td>노출</td>
                                                        <td>4</td>
                                                        <td>5</td>
                                                        <td>6</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>8</td>
                                                        <td>9</td>
                                                        <td>10</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>12</td>
                                                        <td colSpan={2}>...</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div
                                                className="right-table group-input-column"
                                                style={{ justifyContent: 'center' }}
                                            >
                                                <p style={{ display: 'flex' }}>
                                                    <span style={{ fontWeight: '600' }}>{data?.position || ''}</span>
                                                    <span className="note" style={{ marginLeft: '10px' }}>
                                                        ※ 메인화면 프리미엄 배너리스트에서 보여질 위치입니다. 하기
                                                        순서를 참고하시고 등록하세요.
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                </tr> */}
                                <tr>
                                    <th colSpan={2}>
                                        <span>기본배너 사용여부</span>
                                    </th>
                                    <td colSpan={3}>
                                        <fieldset id="UseYn" className="radio-group">
                                            {data?.defaultYN === 'N' && (
                                                <div className="item-checkBox">
                                                    <input
                                                        style={{ cursor: 'default' }}
                                                        className="checkboxDefaultYN"
                                                        type="radio"
                                                        name="defaultYN"
                                                        value="N"
                                                        id="defaultN"
                                                        checked={data?.defaultYN === 'N'}
                                                        readOnly
                                                    />
                                                    <span></span>
                                                    <label htmlFor="defaultN" style={{ paddingLeft: '25px' }}>
                                                        <span style={{ cursor: 'default' }}>사용안함</span>
                                                    </label>
                                                </div>
                                            )}
                                            {data?.defaultYN === 'Y' && (
                                                <div className="item-checkBox">
                                                    <input
                                                        style={{ cursor: 'default' }}
                                                        className="checkboxDefaultYN"
                                                        type="radio"
                                                        name="defaultYN"
                                                        value="Y"
                                                        id="defaultY"
                                                        checked={data?.defaultYN === 'Y'}
                                                        readOnly
                                                    />
                                                    <span></span>
                                                    <label htmlFor="defaultY" style={{ paddingLeft: '25px' }}>
                                                        <span style={{ cursor: 'default' }}>사용함</span>
                                                    </label>
                                                </div>
                                            )}
                                        </fieldset>
                                        <span className="note">
                                            *진행 중인 배너가 없을 경우 메인화면에 기본으로 노출되는 배너를 지정합니다.
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div
                            className="bottom-content"
                            style={{ justifyContent: 'start', gap: '15px', marginTop: '0px', border: 'unset' }}
                        >
                            <Link
                                to={{
                                    pathname: '/maeaa010',
                                    search: location.search,
                                }}
                                className="button-back-to-list"
                                style={{ padding: '0 23px', height: '30px' }}
                            >
                                목록
                            </Link>
                            <div className="button-form">
                                <button
                                    className="btn btn-primary button-back-to-list button-delete"
                                    onClick={() => {
                                        handleDelete();
                                    }}
                                >
                                    삭제
                                </button>
                            </div>
                            <div className="button-form">
                                <button
                                    className="btn btn-primary button-back-to-list"
                                    onClick={() => {
                                        handleReset();
                                    }}
                                >
                                    초기화
                                </button>
                            </div>
                            <div className="button-form">
                                <Link
                                    to={{
                                        pathname: `/maeaa020-${id}`,
                                        search: location.search,
                                    }}
                                    className="btn btn-primary button-save"
                                >
                                    수정
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAEAA030;
